module.exports = __webpack_public_path__ + "static/media/veranda-login-banner3.edbc5ec0.jpg";